import Paster from './paster';
import Text from './text';

export default {
  Paster,
  Text
}